<div class="p-grid" *ngIf="loading || sites.length > 0">
  <div class="form-group p-col-12">
    <label>Existing Locations</label>
    <div *ngIf="loading" class="normalized-address-loading" aria-live="polite">
      <span class="pi pi-spin pi-spinner" aria-hidden="true"></span> Checking for existing locations...
    </div>
    <fieldset *ngIf="!loading && sites.length > 0" class="radio-option-list">
      <legend *ngIf="!readonly" class="p-sr-only">Select an existing location</legend>
      <div
        *ngFor="let site of sites; index as i"
        class="radio-option"
        [class.radio-option--disabled]="readonly"
        (click)="selectSite(site)"
        [attr.role]="!readonly ? 'button' : null"
        [attr.aria-label]="(!readonly ? 'Select duplicate site: ' : 'Duplicate site: ') + site.partySiteName"
      >
        <p-radioButton
          *ngIf="!readonly"
          name="selectedDuplicateSite"
          [value]="site"
          [(ngModel)]="selectedSite"
          [inputId]="'duplicateSite' + i"
        ></p-radioButton>
        <label [for]="!readonly ? 'duplicateSite' + i : null" class="duplicate-site-details">
          <span class="duplicate-site-name">
            {{ site.partySiteName }}
            <ng-container *ngIf="site.chepGlobalLocationId"> - {{ site.chepGlobalLocationId }}</ng-container>
          </span>
          <span class="duplicate-site-address">{{ site.address1 }}, {{ site.city }}, {{ site.state }} {{ site.postalCode }}</span>
        </label>
      </div>
    </fieldset>
  </div>
</div>
